import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../auth/hooks/useAuth';
import {
    fetchLmsIcsEventsData,
    LMS_ICS_GC_MS,
    LMS_ICS_STALE_MS,
    lmsIcsQueryKey,
} from '../hooks/useLmsIcsEvents';

/**
 * After login, warms the LMS ICS query once so Dashboard / Calendar sidebar use cache
 * without refiring the proxy until the user clicks Refresh or relinks LMS.
 */
export default function LmsIcsCacheBootstrap({ children }) {
    const { user, loading } = useAuth();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (loading || !user?.id) return;
        queryClient.prefetchQuery({
            queryKey: lmsIcsQueryKey(user.id),
            queryFn: ({ signal }) => fetchLmsIcsEventsData(user.id, signal),
            staleTime: LMS_ICS_STALE_MS,
            gcTime: LMS_ICS_GC_MS,
        });
    }, [user?.id, loading, queryClient]);

    return children;
}
